import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { EmployeeContractTypeEditor } from "../../../../Talentohumano/GestionTH/EmployeeContract/ComponentsContract/EditorsEmployeContrac/EmployeeContractType.editor";
import { EmploymentTypeEditor } from "../../../../Talentohumano/GestionTH/EmployeeContract/ComponentsContract/EditorsEmployeContrac/EmploymentType.editor";
import { SelectFunctionalID } from "../../../../admin/configuracion/functionalID/SelectFunctionalID";
import { useRequiredFields } from "../../../../theme/Component/hooks/useRequiredFields";
import { PrintJson } from "../../../../theme/Component/PrintJson";


interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

interface Resp {
    IDEmployeeContractType: number;
    IDEmploymentType: number;
    Obs: string;
    IDLnFunctionalID: number;
    IDAppointment: number;
}

export const SCVA001 = ({ configProcedure }: Props) => {

    const props = configProcedure?._pocessData?.Props ?? {};
    const procedure = configProcedure?._procedure ?? {};

    const [response, setResponse] = useState<Partial<Resp>>({})


    useEffect(() => {
        setResponse({
            IDLnFunctionalID: props?.IDLnFunctionalID,
            IDEmployeeContractType: props?.IDEmployeeContractType,
            IDEmploymentType: props?.IDEmploymentType,
        })
    }, [props?.IDLnFunctionalID, props?.IDEmployeeContractType, props?.IDEmploymentType])

    const onExportMap = () => {

        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(response.Obs)
        }
        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(response)
        }
        if (configProcedure?._pushProps) {
            configProcedure?._pushProps({
                IDEmployeeContractType: response.IDEmployeeContractType,
                EmploymentType: response.IDEmploymentType,
                IDLnFunctionalID: response.IDLnFunctionalID,
                IDAppointment: response.IDAppointment
            })
        }
    }

    const { missingFields, validate } = useRequiredFields(response, ["IDEmployeeContractType", "IDEmploymentType", "IDLnFunctionalID"]);

    const validateData = () => {
        if (validate() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            onExportMap();
        }
    }

    return (
        <div className="row">
            <div className="col-md-6">
                <label className={`${missingFields.includes('IDEmployeeContractType') ? 'has-error' : ''}`}>Tipo de Contrato Laboral</label>
                <EmployeeContractTypeEditor label=" " idSelector={response.IDEmployeeContractType} onChange={(e) => { setResponse({ ...response, "IDEmployeeContractType": e }) }} />
            </div>
            <div className="col-md-6">
                <label className={`${missingFields.includes('IDEmploymentType') ? 'has-error' : ''}`}>Tipo de Grupo Laboral</label>
                <EmploymentTypeEditor label=" " idSelector={response.IDEmploymentType} onChange={(e) => { setResponse({ ...response, "IDEmploymentType": e }) }} />
            </div>
            <div className="col-md-6">
                <label className={`${missingFields.includes('IDLnFunctionalID') ? 'has-error' : ''}`}>Unidad Organizacional</label>
                <SelectFunctionalID disable={props.IDLnFunctionalID} functionalIDLn={response.IDLnFunctionalID} label=" " onChange={(e) => { setResponse({ ...response, "IDLnFunctionalID": e?.IDLn }) }} />
            </div>
            <div className="col-md-12">
                <label>Observaciones</label>
                <textarea className="form-control" value={response.Obs} onChange={(e) => { setResponse({ ...response, "Obs": e.target.value }) }} />
            </div>

            <div className="col-md-12 mt-2">
                <BasicButton eventClick={validateData} icon="ri-send-plane-line" children={"Continuar"} />
            </div>
        </div>
    );
}